var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNav4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1740_7892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.17157 1H5C3.11438 1 2.17157 1 1.58579 1.58579C1 2.17157 1 3.11438 1 5V15C1 16.8856 1 17.8284 1.58579 18.4142C2.17157 19 3.11438 19 5 19H11C12.8856 19 13.8284 19 14.4142 18.4142C15 17.8284 15 16.8856 15 15V6.82843C15 6.41968 15 6.2153 14.9239 6.03153C14.8478 5.84776 14.7032 5.70324 14.4142 5.41421L10.5858 1.58579C10.2968 1.29676 10.1522 1.15224 9.96847 1.07612C9.7847 1 9.58032 1 9.17157 1Z",
    stroke: "#9B9B9B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 11L11 11",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 15L9 15",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 1V5C9 5.94281 9 6.41421 9.29289 6.70711C9.58579 7 10.0572 7 11 7H15",
    stroke: "#9B9B9B",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1740_7892",
    x: 0,
    y: 0,
    width: 16.3338,
    height: 20.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.333328,
    dy: 0.333328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.666656
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19534 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1740_7892"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNav4);
export default __webpack_public_path__ + "static/media/nav4.10725fccf310bc481c1a29e9f6ef7582.svg";
export { ForwardRef as ReactComponent };